import $ from 'jquery';
import Headroom from 'headroom.js';
import { Fancybox } from '@fancyapps/ui';
// eslint-disable-next-line no-unused-vars
import { Collapse, Modal } from 'bootstrap';
import ClipboardJS from 'clipboard';
import 'sharer.js';
import Swiper from 'swiper';
import 'bootstrap';

// eslint-disable-next-line no-undef
const object = onscObject;

$('.wp-block-gallery').each(function (i) {
    $(this).attr('data-block-gallery', i);
    const items = $(`[data-block-gallery=${i}]`).find(
        'a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]'
    );
    items.attr('data-fancybox', `block-gallery-${i}`);

    Fancybox.bind(`[data-block-gallery=${i}]`);
});

const clipBoard = new ClipboardJS('.onsc-clipboard');

clipBoard.on('success', function (e) {
    const $this = $(e.trigger);

    $this.addClass('onsc-clipboard--success');

    setTimeout(function () {
        $this.removeClass('onsc-clipboard--success');
    }, 3000);
});

const header = document.querySelector('.site-header');
const headroom = new Headroom(header, {
    classes: {
        initial: 'site-header-fixed',
        pinned: 'site-header__pinned',
        unpinned: 'site-header__unpinned',
        top: 'site-header__top',
        notTop: 'site-header__not-top',
        bottom: 'site-header__bottom',
        notBottom: 'site-header__not-bottom',
        frozen: 'site-header__frozen',
    },
});
headroom.init();

$(document).on('click', '.client_account', (e) => {
    if (e.target !== e.currentTarget) return;
    $('.header-share').toggleClass('header-share--active');
    $('body').toggleClass('no-blend');
});

$(document).on('click', '.header-share-toggle', (e) => {
    if (e.target !== e.currentTarget) return;
    $('.header-share').toggleClass('header-share--active');
    $('body').toggleClass('no-blend');
});

$(document).on('click', (e) => {
    if ($(e.target).closest('.header-share-toggle').length === 0) {
        $('.header-share').removeClass('header-share--active');
        $('body').removeClass('no-blend');
    }
});

$(document).on('click', '.menu-item-has-children > a', function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    const currentList = $(this).closest('li');
    const currentMenu = currentList.find('.sub-menu');
    const currentIcon = $(this).find('i');

    currentList.toggleClass('submenu-active');
    currentMenu.slideToggle('300');
    currentIcon.toggleClass('onsc-icons-plus onsc-icons-minus');
});



$('.visio-conf').hover(
    function () {
        $(".onsc-icons-icon-visio-white").addClass('onsc-icons-icon-golden-circle').removeClass('onsc-icons-icon-visio-white');
        },
    function () {
        $(".onsc-icons-icon-golden-circle").addClass('onsc-icons-icon-visio-white').removeClass('onsc-icons-icon-golden-circle');
    }
);

$('.client_account').hover(
    function (){
        $('.header-client').toggleClass('header-client--active',1000, "easeOutSine");
    },
    function (){
        $('.header-client').toggleClass('header-client--active',1000, "easeOutSine");
    }
)



$(document).on('click', '.header-nav-toggle', function () {
    $('.header-nav').toggleClass('header-nav--active');

    $('body').toggleClass('menu-active');

    $(document).trigger('onscModal', {
        open: $('.header-nav').hasClass('header-nav--active'),
    });
});

$(document).on('onscModal', (e, args) => {
    if (args.open) {
        $('body').addClass('menu-open');
    } else {
        $('body').removeClass('menu-open');
    }
});

const jsContainer = () => {
    if ($('.js-container').length) {
        const bodyWidth = $('body').outerWidth();
        $('.js-container').css({
            width: bodyWidth,
            marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
        });
    }
};

$(window).bind('resize', jsContainer).trigger('resize');

$(document).on('click', '.share-block__toggle', function () {
    $(this).parents('.share-block').toggleClass('share-block--active');
});

$('.blog-page__filter-select--action').on('change', function () {
    window.location.href = $(this).val();
});


new Swiper('.blog-post-template__related-slider', {
    slidesPerView: 1,
    spaceBetween: 30,
    watchOverflow: true,
    breakpoints: {
        992: {
            slidesPerView: 2,
        },
    },
});

$('.blog-filter__select').on('change', function () {
    window.location.href = $(this).val();
});
